import styled from 'styled-components';

export const Container = styled.div``;

export const EmptyIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;

  font-size: 9.2rem;
  color: ${({ theme }) => theme.palette.grey[400]};
`;
